import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';

export default class ChatCounterDirectiveController {
    static $inject = [ '$scope', 'CatalogChatService' ];

    constructor(scope, ChatService) {
        this._scope = scope;
        this._chatService = ChatService;

        this._chatService.getUnreadMessages().then(resp => scope.count = resp);

        this._scope.$on(Constants.Events.CHAT_MESSAGE_RECEIVED, (scope, unreadMessages) => {
            this._scope.count = unreadMessages;
            scopeUtils.apply(this._scope);
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/directives/ChatCounterDirective.js